import { Card, CardContent, Grid, Typography } from "@mui/material";
import type { BranchItemProps } from "./types/BranchItemProps";

export function BranchItem({ name, icon: IconComponent }: BranchItemProps) {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} sx={{ marginBottom: 3 }}>
      <Card
        elevation={0}
        sx={{
          height: "100%",
          textAlign: "center",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        }}
      >
        <CardContent>
          <IconComponent
            sx={{
              color: "primary.main",
              fontSize: "3rem",
              marginBottom: 1,
            }}
          />

          <Typography
            variant="subtitle1"
            sx={{
              color: "primary.main",
              fontWeight: "bold",
            }}
          >
            {name}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
